import { testConnectorConfigInoplaDefinition } from "@snubes/snubes-types";
import { getCallable } from "../../Firebase/helpers/getCallable";

export const testConnectorConfigInoplaCallable = getCallable(
  testConnectorConfigInoplaDefinition,
);
